import * as Menubar from '@radix-ui/react-menubar';
import { Box, Flex, Text } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { IMenuBarItem } from 'interfaces/i-menu-bars';
import { useMemo } from 'react';

export const CommonMenuBarItems = (props: { items: IMenuBarItem[] }) => {
  const visibleItems = useMemo(
    () => props.items.filter((m) => !m.invisible),
    [props.items]
  );

  return (
    <ErrorBoundary identifier="CommonMenuBarItems">
      {visibleItems.length > 0 && (
        <Menubar.Content className="MenuContent">
          <Flex direction="column" gap="1">
            {visibleItems.map((item) => (
              <Menubar.Item
                key={item.id}
                className="MenuItem"
                disabled={item.disabled}
                onClick={item.disabled ? undefined : item.onClick}
              >
                <Flex gap="1" align="center" style={{ width: '100%' }}>
                  {item.startSlot}
                  <Text
                    color={item.color}
                    style={item.startSlot ? { marginLeft: '4px' } : undefined}
                  >
                    {item.label}
                  </Text>
                  {item.endSlot && <Box flexGrow="1">{/* placeholder */}</Box>}
                  {item.endSlot}
                </Flex>
              </Menubar.Item>
            ))}
          </Flex>
        </Menubar.Content>
      )}
    </ErrorBoundary>
  );
};
